const { REACT_APP_LOST_FOUND_URL, REACT_APP_LOST_FOUND_ACCESS_TOKEN } =
  process.env;

const registerLostItemApi = () => {
  return {
    headers: {
      username: "p90meg",
      emquest_access_token: REACT_APP_LOST_FOUND_ACCESS_TOKEN,
    },
    apiUrl: REACT_APP_LOST_FOUND_URL + `/lost_and_found/register_lost_item`,
  };
};

export default registerLostItemApi;
